export const getEditedReport = state => state.reportEditable;
export const getReport = state => state.report;
export const getSession = state => state.session;
export const getLocalities = state => state.localities;
export const getTilaajavastuuToken = state => {
  if (!state.session.logins) return null;
  if (!state.session.logins.tilaajavastuu) return null;
  return state.session.logins.tilaajavastuu.token;
};
export const isSuperUser = state => {
  if (!state.session.logins) return false;
  if (!state.session.logins.tilaajavastuu) return false;
  if (!state.session.logins.tilaajavastuu.client) return false;
  return state.session.logins.tilaajavastuu.client.super_user;
};
export const getCurrentUser = state => {
  if (!state.session.logins) return false;
  if (!state.session.logins.tilaajavastuu) return false;
  if (!state.session.logins.tilaajavastuu.client) return false;
  return state.session.logins.tilaajavastuu.client;
};
export const getActiveCompany = state => {
  if (!state.report) return null;
  return {
    country: state.report.country,
    id: state.report.companyId,
    identifier: state.report.identifier,
  };
};
export const getActiveCompanyContactPersons = state => {
  const activeCompany = getActiveCompany(state);
  if (!activeCompany) return null;
  const { id: companyId } = activeCompany;
  const { byCompanyId } = state.contactPersons;
  return byCompanyId[companyId] || null;
};
export const companyHasActiveLicense = state => {
  if (!state.report) return false;
  return !!state.report.portfolio_enabled;
}
export const getActiveCompanyCurrentLicense = state => {
  let currentLicense;
  const licenses = getActiveCompanyLicenses(state);
  if (licenses) {
    currentLicense = licenses.find(
      l => ['ordered', 'pending'].indexOf(
        l.toComparable('license.status')
      ) !== -1
    );
  }
  return currentLicense || null;
}
export const showPaidFeatureControls = state => {
  const activeLicenseExists = companyHasActiveLicense(state);
  if (activeLicenseExists) {
    return true;
  }
  const currentLicense = getActiveCompanyCurrentLicense(state);
  if (currentLicense) {
    return true;
  }
  return false;
}
export const getActiveCompanyLicensesFetchState = state => {
  const activeCompany = getActiveCompany(state);
  if (!activeCompany) {
    return null;
  }
  const { country, identifier } = activeCompany;
  const {
    licenses: {
      companyLicenses: {
        [`${country}/${identifier}`]: companyLicenses,
      },
    },
  } = state;
  if (!companyLicenses) {
    return null;
  }
  return companyLicenses.state;
}
export const getActiveCompanyLicenses = state => {
  const activeCompany = getActiveCompany(state);
  if (!activeCompany) {
    return null;
  }
  const { country, identifier } = activeCompany;
  const {
    licenses: {
      licenses: { items: allLicenses },
      companyLicenses: {
        [`${country}/${identifier}`]: companyLicenses,
      },
    },
  } = state;
  if (!companyLicenses) {
    return [];
  }
  return allLicenses.filter(
    l => companyLicenses.licenseIds.indexOf(l.id) !== -1
  );
}
export const getActiveCompanyContactInfo = state => {
  if (!state.report) return null;
  return state.report.contact_information;
}
export const getLicenseTypes = state => state.licenses.types.items;
export const getLicenseSellers = state => state.licenses.sellers.items;
export const getActionLog = (state, entity) => state[entity].actionLog;
export const getQuickCheck = (state, company) =>
  state.quickChecks.byCompanyId[company.id];
